import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">焦点专题</h2>
          <p className="text-sm text-foreground-500">深度策划与独家专题，换一个角度看娱乐圈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer"
            >
              <div className="relative w-full h-[200px] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}